// @flow
import React, { PureComponent, type ComponentType } from "react";
import { getDisplayName } from "data/constants";
import SearchOperators from "components/SearchOperators";
import { type SearchOperatorEnum, type SearchValueTypeEnum } from "data/types";

type Props = {
    /** currently selected searchOperator */
    searchOperator: SearchOperatorEnum,
    /** callback when value has been changed
     * @param {string} name field's name
     * @param {any} value new field's value
     */
    onChange: (name: string, value: any) => void,
    /** current value */
    value: any,
    /** current name */
    name: string,
    /** current valueType */
    valueType: SearchValueTypeEnum,
};

type State = {
    /** currently selected searchOperator */
    op: SearchOperatorEnum,
    /** current value */
    value: any,
};

/** wraps *EditorControls to add Search Operators and handling */
const toSearchEditor = (WrappedComponent: ComponentType<any>) =>
    class PP extends PureComponent<Props, State> {
        upstreamOnChange: (name: string, value: any) => void;
        // opRef: ElementRef<*>;

        static displayName = `toSearchEditor(${getDisplayName(
            WrappedComponent
        )})`;

        constructor(props: Props) {
            super(props);
            this.state = {
                op: props.searchOperator,
                value: props.value,
            };
            this.upstreamOnChange = this.props.onChange;
            // this.opRef = React.createRef();
        }

        _onChange = () => {
            this.upstreamOnChange(this.props.name, {
                op: this.state.op,
                val: this.state.value,
            });
        };

        _onChangeValue = (name: string, value: any) =>
            this.setState({ value }, this._onChange);

        _onChangeOperator = (op: SearchOperatorEnum) =>
            this.setState({ op, value: null }, this._onChange);

        // _focusNextInput = (node: React.Element) => {
        //     if (this.opRef == null || this.opRef.current == null) return null;
        //     const input = this.opRef.current.parentNode.querySelector("input");
        //     if (input != null) input.focus();
        // };

        render = () => (
            <WrappedComponent
                {...this.props}
                onChange={this._onChangeValue}
                afterHeaderComponentClass={
                    /*istanbul ignore next */ () => (
                        <SearchOperators
                            // selectRef={this.opRef}
                            valueType={this.props.valueType}
                            value={this.props.searchOperator}
                            onChange={this._onChangeOperator}
                        />
                    )
                }
            />
        );
    };

export default toSearchEditor;
